module.exports = __webpack_public_path__ + "img/messenger.632a6dc2.png";